import React, { useContext } from "react";
// import Image from "../../assets/images/image.png";
import constants from "../../constants";
// import Lottie from "react-lottie";
// import * as animationData from "./Animation - 1733564331870.json";
import moment from "moment";
import Tooltip from "./Tooltip";
import { getDataFromStorage, MANAGEMENTROLES, USERSROLES } from "../../util";
import ToggleButton from "./ToggleButton";
import IconButton from "./IconButton";
import AlertContext from "../../context/AlertContext";
import TestDueHooks from "../../Hooks/TestDueHooks";
// import IconButton from "./IconButton";

// const defaultOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: animationData,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice",
//   },
// };

const HackathonCard = ({
  role,
  item,
  onClick,
  onDelete,
  onChangeRecommend,
}) => {
  const { setShowNotify } = useContext(AlertContext);

  const { currentDueLabel } = TestDueHooks();

  const isWithinOneWeek = moment(item.createddate).isBetween(
    moment(),
    moment().add(3, "days"),
    "days",
    "[]"
  );

  const formatDateRange = (startdate, enddate) => {
    if (!startdate) return ""; // Handle cases where startdate is missing

    const start = moment(startdate);
    const end = moment(enddate);

    if (!enddate) {
      return start.format("Do MMMM YYYY");
    }

    if (start.isSame(end, "day")) {
      return start.format("Do MMMM YYYY");
    } else if (start.isSame(end, "month") && start.isSame(end, "year")) {
      return `${start.format("Do")} - ${end.format("Do MMMM YYYY")}`;
    } else if (start.isSame(end, "year")) {
      return `${start.format("Do MMMM")} - ${end.format("Do MMMM YYYY")}`;
    } else {
      return `${start.format("Do MMMM YYYY")} - ${end.format("Do MMMM YYYY")}`;
    }
  };

  const onToggleRecommend = async (value) => {
    onChangeRecommend(item.id, value);
  };

  return (
    <div className="hackathonCardContainer" onClick={() => onClick(item)}>
      {USERSROLES.includes(getDataFromStorage("role")) && item.isrecommended ? (
        <div className="hackathonCardRecommendedSec">
          <svg
            width="110"
            height="92"
            viewBox="0 0 110 92"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M88.7909 87.5L96.2909 83L96.7909 82.5L88.7909 76.5001L88.7909 87.5Z"
              fill="#7A271A"
            />
            <path
              d="M5.27195 18.9999L12.7904 18.9998L6.29042 13.9998L5.79053 14L5.27195 18.9999Z"
              fill="#B42318"
            />
            <path
              d="M5.79081 13.8993L22.732 4.85819L99.7128 63.1565L96.671 82.7237L5.79081 13.8993Z"
              fill="url(#paint0_linear_9766_87619)"
            />
            <g filter="url(#filter0_dd_9766_87619)">
              <path
                d="M23.8444 21.4543L28.2351 15.6565L30.3017 17.2216C30.7508 17.5618 31.065 17.9214 31.2441 18.3006C31.4251 18.6812 31.4856 19.064 31.4255 19.4492C31.3669 19.8324 31.2026 20.2024 30.9324 20.5591C30.6637 20.9139 30.3526 21.1698 29.9991 21.3268C29.649 21.4833 29.2683 21.5232 28.8572 21.4464C28.448 21.3711 28.0188 21.1634 27.5696 20.8232L26.0041 19.6377L26.5744 18.8846L28.0607 20.0102C28.3438 20.2246 28.6047 20.3584 28.8436 20.4116C29.0843 20.4662 29.3048 20.4476 29.5051 20.3557C29.7053 20.2638 29.8876 20.1094 30.052 19.8923C30.2178 19.6734 30.319 19.4516 30.3555 19.2268C30.394 19.0035 30.3557 18.7815 30.2407 18.5608C30.1291 18.3396 29.9289 18.1197 29.6401 17.901L28.5417 17.0692L24.7191 22.1168L23.8444 21.4543ZM28.6874 21.006L28.1389 24.7066L27.1424 23.952L27.7192 20.2728L28.6874 21.006ZM30.9866 27.0013C30.5582 26.6768 30.2585 26.3059 30.0877 25.8884C29.9201 25.4705 29.8788 25.0309 29.9638 24.5697C30.0522 24.1079 30.2671 23.6515 30.6087 23.2005C30.946 22.7551 31.3263 22.4254 31.7497 22.2115C32.1749 21.999 32.6098 21.911 33.0542 21.9477C33.5005 21.9857 33.9256 22.1577 34.3295 22.4636C34.5749 22.6494 34.7819 22.87 34.9507 23.1256C35.1195 23.3811 35.2297 23.665 35.2813 23.9772C35.3329 24.2895 35.3064 24.6244 35.202 24.9819C35.099 25.3374 34.8982 25.7125 34.5995 26.1069L34.3722 26.407L30.9156 23.7893L31.3959 23.1551L34.023 25.1447C34.1916 24.922 34.2957 24.6905 34.3352 24.4501C34.3761 24.2079 34.3523 23.9746 34.2639 23.7502C34.1773 23.5273 34.0246 23.3329 33.8056 23.1671C33.5678 22.987 33.3159 22.8883 33.0499 22.871C32.7872 22.8532 32.537 22.9012 32.2992 23.0152C32.0648 23.1287 31.8654 23.2939 31.701 23.511L31.3258 24.0064C31.1057 24.297 30.9695 24.5829 30.917 24.8639C30.8665 25.1463 30.8929 25.4113 30.9964 25.659C31.1013 25.9048 31.2774 26.1212 31.5246 26.3085C31.6851 26.43 31.8485 26.5181 32.0149 26.5728C32.1827 26.6257 32.3498 26.6423 32.5161 26.6228C32.6824 26.6032 32.8424 26.5447 32.9963 26.4474L33.6881 27.1985C33.4453 27.3859 33.1737 27.5053 32.8732 27.557C32.5761 27.6081 32.2658 27.5885 31.9424 27.4979C31.6223 27.407 31.3037 27.2414 30.9866 27.0013ZM35.9419 30.754C35.521 30.4352 35.2308 30.0655 35.0713 29.6448C34.9151 29.2236 34.8838 28.7826 34.9773 28.3219C35.0709 27.8611 35.2827 27.4128 35.6129 26.9768C35.9473 26.5352 36.3255 26.2083 36.7474 25.9963C37.1708 25.7824 37.6056 25.6944 38.0519 25.7325C38.4983 25.7706 38.9262 25.9447 39.3357 26.2548C39.666 26.5049 39.914 26.7892 40.0796 27.1077C40.2467 27.4243 40.3266 27.7521 40.3194 28.0911C40.314 28.4315 40.2156 28.7594 40.0243 29.0748L39.2005 28.4509C39.3096 28.2128 39.3387 27.9587 39.2879 27.6886C39.2389 27.4199 39.0795 27.1833 38.8096 26.9789C38.5737 26.8003 38.3199 26.706 38.0481 26.6963C37.7797 26.686 37.51 26.7579 37.2389 26.9119C36.9692 27.0641 36.7172 27.2949 36.4828 27.6045C36.2427 27.9215 36.0836 28.2316 36.0055 28.5348C35.9273 28.8379 35.9282 29.1192 36.0079 29.3785C36.0896 29.6393 36.2502 29.8605 36.4899 30.042C36.6503 30.1635 36.8178 30.2443 36.9923 30.2844C37.1702 30.3241 37.3456 30.3218 37.5187 30.2776C37.6936 30.2349 37.8583 30.1488 38.0128 30.0193L38.8366 30.6432C38.5934 30.9015 38.3118 31.0832 37.9917 31.1882C37.6716 31.2933 37.3353 31.3118 36.9829 31.2439C36.6324 31.1774 36.2853 31.0141 35.9419 30.754ZM40.7839 34.4209C40.3762 34.1121 40.0912 33.7493 39.9289 33.3324C39.7665 32.9154 39.7285 32.4753 39.815 32.0122C39.9014 31.5491 40.1147 31.0929 40.4549 30.6437C40.7965 30.1927 41.1792 29.8618 41.603 29.6512C42.0268 29.4406 42.4614 29.3569 42.9067 29.4002C43.3521 29.4434 43.7786 29.6194 44.1862 29.9282C44.5939 30.2369 44.8789 30.5997 45.0413 31.0167C45.2036 31.4336 45.2409 31.8746 45.153 32.3396C45.0651 32.8047 44.8504 33.2627 44.5088 33.7138C44.1686 34.163 43.7874 34.4919 43.365 34.7007C42.9426 34.9094 42.5087 34.9921 42.0634 34.9489C41.618 34.9056 41.1915 34.7296 40.7839 34.4209ZM41.3248 33.7124C41.589 33.9125 41.8609 34.0085 42.1403 34.0003C42.4197 33.9922 42.6888 33.9035 42.9476 33.7342C43.2083 33.5664 43.4445 33.3428 43.656 33.0635C43.8661 32.7861 44.0166 32.4991 44.1075 32.2027C44.2016 31.9058 44.2155 31.6208 44.1491 31.3477C44.0827 31.0747 43.9173 30.8381 43.6531 30.638C43.387 30.4365 43.1126 30.3401 42.8299 30.3487C42.549 30.3587 42.2776 30.4486 42.0154 30.6183C41.7566 30.7876 41.5221 31.0109 41.312 31.2884C41.1004 31.5677 40.9483 31.8548 40.8555 32.1499C40.7647 32.4463 40.7532 32.7301 40.821 33.0013C40.8908 33.2739 41.0587 33.5109 41.3248 33.7124ZM44.141 36.8252L47.434 32.4768L48.2465 33.0921L47.7105 33.7999L47.7643 33.8406C48.0364 33.6695 48.3261 33.5949 48.6333 33.6167C48.9419 33.6366 49.2396 33.7551 49.5265 33.9724C49.8172 34.1925 50.0092 34.4448 50.1025 34.7293C50.1978 35.0153 50.2026 35.3129 50.1168 35.6222L50.1621 35.6565C50.4417 35.503 50.7469 35.4431 51.0778 35.4768C51.41 35.5086 51.7328 35.6432 52.0461 35.8805C52.4405 36.1792 52.6687 36.5465 52.7306 36.9824C52.7943 37.4197 52.6376 37.8875 52.2602 38.3858L50.052 41.3016L49.2056 40.6606L51.3538 37.824C51.5767 37.5296 51.658 37.2556 51.5976 37.002C51.5373 36.7484 51.3957 36.5372 51.173 36.3686C50.8975 36.1599 50.619 36.0826 50.3375 36.1367C50.0574 36.1889 49.8173 36.3471 49.6172 36.6113L47.5183 39.3828L46.6747 38.7439L48.8636 35.8536C49.0423 35.6176 49.1123 35.3722 49.0737 35.1173C49.0351 34.8624 48.8979 34.6456 48.662 34.4669C48.5016 34.3455 48.3213 34.2757 48.1211 34.2577C47.9242 34.2393 47.7277 34.2732 47.5318 34.3594C47.3377 34.447 47.1664 34.589 47.0177 34.7853L44.9875 37.4662L44.141 36.8252ZM51.5054 42.4023L54.7984 38.0539L55.6109 38.6692L55.0749 39.377L55.1287 39.4177C55.4008 39.2466 55.6905 39.172 55.9977 39.1938C56.3063 39.2137 56.604 39.3323 56.8909 39.5495C57.1816 39.7696 57.3736 40.0219 57.4669 40.3065C57.5622 40.5924 57.567 40.89 57.4812 41.1993L57.5265 41.2336C57.8061 41.0801 58.1113 41.0202 58.4422 41.0539C58.7744 41.0858 59.0972 41.2203 59.4104 41.4576C59.8049 41.7563 60.0331 42.1236 60.095 42.5595C60.1587 42.9968 60.002 43.4646 59.6246 43.9629L57.4164 46.8788L56.57 46.2377L58.7181 43.4011C58.9411 43.1067 59.0224 42.8327 58.962 42.5791C58.9017 42.3255 58.7601 42.1144 58.5374 41.9457C58.2619 41.737 57.9834 41.6597 57.7019 41.7138C57.4218 41.766 57.1817 41.9242 56.9816 42.1885L54.8827 44.96L54.0391 44.3211L56.228 41.4307C56.4067 41.1948 56.4767 40.9494 56.4381 40.6944C56.3995 40.4395 56.2623 40.2227 56.0264 40.0441C55.866 39.9226 55.6856 39.8528 55.4854 39.8349C55.2886 39.8164 55.0921 39.8503 54.8962 39.9365C54.7021 40.0242 54.5308 40.1661 54.3821 40.3624L52.3518 43.0433L51.5054 42.4023ZM60.6774 49.4864C60.249 49.162 59.9493 48.791 59.7785 48.3736C59.6109 47.9556 59.5696 47.516 59.6546 47.0548C59.743 46.5931 59.9579 46.1367 60.2995 45.6856C60.6368 45.2402 61.0172 44.9106 61.4405 44.6966C61.8658 44.4841 62.3006 44.3962 62.745 44.4328C63.1914 44.4709 63.6165 44.6428 64.0203 44.9487C64.2657 45.1345 64.4728 45.3552 64.6415 45.6107C64.8103 45.8662 64.9205 46.1501 64.9721 46.4624C65.0237 46.7747 64.9973 47.1095 64.8928 47.467C64.7899 47.8226 64.589 48.1976 64.2903 48.592L64.063 48.8921L60.6064 46.2744L61.0867 45.6403L63.7138 47.6298C63.8825 47.4071 63.9865 47.1756 64.026 46.9353C64.0669 46.693 64.0431 46.4597 63.9547 46.2353C63.8681 46.0124 63.7154 45.818 63.4965 45.6522C63.2587 45.4721 63.0067 45.3734 62.7407 45.3561C62.478 45.3383 62.2278 45.3864 61.99 45.5003C61.7556 45.6138 61.5562 45.7791 61.3918 45.9961L61.0167 46.4915C60.7966 46.7822 60.6603 47.068 60.6078 47.349C60.5573 47.6314 60.5837 47.8965 60.6872 48.1441C60.7921 48.3899 60.9682 48.6064 61.2154 48.7936C61.3759 48.9151 61.5393 49.0032 61.7057 49.058C61.8735 49.1108 62.0406 49.1275 62.2069 49.1079C62.3732 49.0883 62.5333 49.0299 62.6871 48.9326L63.3789 49.6837C63.1361 49.871 62.8645 49.9905 62.564 50.0421C62.2669 50.0933 61.9566 50.0736 61.6332 49.9831C61.3131 49.8921 60.9945 49.7265 60.6774 49.4864ZM66.6692 49.8234L64.714 52.4053L63.8675 51.7642L67.1605 47.4159L67.973 48.0312L67.437 48.7389L67.4908 48.7797C67.7652 48.6252 68.0619 48.5588 68.381 48.5807C68.7019 48.604 69.0256 48.7392 69.3521 48.9865C69.6484 49.2109 69.8608 49.4697 69.9891 49.7629C70.1189 50.0542 70.153 50.3681 70.0913 50.7045C70.0296 51.0408 69.8629 51.3883 69.5914 51.7469L67.4968 54.5127L66.6503 53.8717L68.6677 51.2078C68.9064 50.8926 69.0108 50.5841 68.981 50.2824C68.9526 49.9787 68.7949 49.7183 68.5081 49.501C68.3118 49.3524 68.1051 49.2627 67.8879 49.2318C67.6726 49.2024 67.4584 49.2362 67.2454 49.3332C67.0356 49.4298 66.8436 49.5932 66.6692 49.8234ZM70.5143 56.9316C70.1633 56.6657 69.9179 56.3388 69.7781 55.9509C69.6417 55.5624 69.6216 55.1419 69.718 54.6892C69.8176 54.2361 70.0454 53.7745 70.4013 53.3046C70.7572 52.8347 71.1399 52.492 71.5496 52.2766C71.9611 52.0626 72.3718 51.9712 72.7817 52.0025C73.1916 52.0337 73.5711 52.1816 73.9202 52.446C74.1901 52.6504 74.3729 52.86 74.4684 53.075C74.5674 53.2895 74.6171 53.4904 74.6176 53.6779C74.6201 53.8669 74.6125 54.0259 74.5948 54.1551L74.6458 54.1937L76.2773 52.0394L77.1237 52.6804L72.733 58.4782L71.9064 57.8521L72.4188 57.1755L72.348 57.1219C72.227 57.1758 72.0734 57.2258 71.8871 57.2718C71.7027 57.3192 71.4938 57.3244 71.2606 57.2873C71.0273 57.2503 70.7786 57.1317 70.5143 56.9316ZM71.2479 56.3512C71.4913 56.5356 71.7457 56.6272 72.0108 56.6261C72.2793 56.6245 72.5441 56.5414 72.8053 56.3769C73.0684 56.2138 73.3157 55.9794 73.5472 55.6737C73.7759 55.3717 73.9326 55.0746 74.0173 54.7824C74.102 54.4902 74.1082 54.2172 74.036 53.9636C73.9638 53.7099 73.8041 53.4895 73.5569 53.3023C73.3021 53.1093 73.0397 53.0146 72.7698 53.018C72.4999 53.0215 72.2351 53.1046 71.9753 53.2672C71.7175 53.4312 71.4799 53.6567 71.2627 53.9436C71.0426 54.2342 70.888 54.5285 70.799 54.8264C70.71 55.1242 70.699 55.4054 70.766 55.67C70.8362 55.934 70.9969 56.1611 71.2479 56.3512ZM76.0676 61.1416C75.6392 60.8171 75.3396 60.4462 75.1687 60.0287C75.0011 59.6108 74.9598 59.1712 75.0449 58.7099C75.1332 58.2482 75.3481 57.7918 75.6897 57.3408C76.027 56.8954 76.4074 56.5657 76.8307 56.3518C77.256 56.1393 77.6908 56.0513 78.1352 56.088C78.5816 56.126 79.0067 56.298 79.4105 56.6039C79.6559 56.7897 79.863 57.0103 80.0318 57.2658C80.2005 57.5214 80.3107 57.8053 80.3623 58.1175C80.4139 58.4298 80.3875 58.7647 80.283 59.1221C80.1801 59.4777 79.9792 59.8527 79.6805 60.2472L79.4532 60.5473L75.9967 57.9296L76.4769 57.2954L79.104 59.285C79.2727 59.0623 79.3767 58.8308 79.4162 58.5904C79.4571 58.3482 79.4333 58.1149 79.3449 57.8905C79.2583 57.6675 79.1056 57.4732 78.8867 57.3074C78.6489 57.1273 78.397 57.0286 78.1309 57.0112C77.8682 56.9934 77.618 57.0415 77.3802 57.1555C77.1458 57.269 76.9464 57.4342 76.7821 57.6513L76.4069 58.1467C76.1868 58.4373 76.0505 58.7232 75.998 59.0042C75.9475 59.2866 75.9739 59.5516 76.0774 59.7993C76.1823 60.045 76.3584 60.2615 76.6057 60.4488C76.7661 60.5703 76.9295 60.6584 77.0959 60.7131C77.2637 60.766 77.4308 60.7826 77.5971 60.7631C77.7634 60.7435 77.9235 60.685 78.0773 60.5877L78.7691 61.3388C78.5263 61.5262 78.2547 61.6456 77.9543 61.6973C77.6571 61.7484 77.3469 61.7288 77.0234 61.6382C76.7033 61.5472 76.3847 61.3817 76.0676 61.1416ZM80.8212 64.7371C80.4702 64.4712 80.2248 64.1443 80.085 63.7563C79.9485 63.3679 79.9285 62.9474 80.0248 62.4947C80.1245 62.0415 80.3522 61.58 80.7081 61.1101C81.064 60.6401 81.4468 60.2975 81.8564 60.082C82.2679 59.868 82.6786 59.7767 83.0885 59.8079C83.4984 59.8392 83.8779 59.9871 84.2271 60.2515C84.497 60.4559 84.6797 60.6655 84.7753 60.8804C84.8742 61.0949 84.9239 61.2959 84.9245 61.4834C84.9269 61.6724 84.9193 61.8314 84.9017 61.9606L84.9526 61.9992L86.5841 59.8448L87.4306 60.4859L83.0399 66.2836L82.2132 65.6576L82.7256 64.981L82.6548 64.9274C82.5339 64.9813 82.3802 65.0313 82.1939 65.0773C82.0095 65.1247 81.8007 65.1299 81.5674 65.0928C81.3342 65.0557 81.0854 64.9372 80.8212 64.7371ZM81.5547 64.1567C81.7982 64.341 82.0525 64.4327 82.3177 64.4315C82.5861 64.4299 82.851 64.3469 83.1122 64.1824C83.3752 64.0193 83.6225 63.7849 83.8541 63.4792C84.0828 63.1772 84.2395 62.8801 84.3241 62.5879C84.4088 62.2957 84.4151 62.0227 84.3429 61.7691C84.2707 61.5154 84.111 61.295 83.8637 61.1077C83.6089 60.9148 83.3466 60.82 83.0767 60.8235C82.8068 60.827 82.5419 60.91 82.2822 61.0727C82.0243 61.2367 81.7868 61.4622 81.5695 61.749C81.3494 62.0397 81.1949 62.3339 81.1059 62.6318C81.0169 62.9297 81.0059 63.2109 81.0728 63.4754C81.1431 63.7395 81.3037 63.9666 81.5547 64.1567Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_dd_9766_87619"
                x="17.7778"
                y="13.6565"
                width="75.6528"
                height="62.7148"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="2"
                  operator="erode"
                  in="SourceAlpha"
                  result="effect1_dropShadow_9766_87619"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_9766_87619"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="2"
                  operator="erode"
                  in="SourceAlpha"
                  result="effect2_dropShadow_9766_87619"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_9766_87619"
                  result="effect2_dropShadow_9766_87619"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect2_dropShadow_9766_87619"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_9766_87619"
                x1="11.0539"
                y1="6.94966"
                x2="101.934"
                y2="75.7741"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF392B" />
                <stop offset="1" stopColor="#89514D" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      ) : null}
      <img
        className="hackathonPoster"
        src={`https://${process.env.REACT_APP_S3_WEBSITE_HOST_BUCKET_NAME}.s3.ap-south-1.amazonaws.com/${item.poster}`}
        alt="Poster"
        height="fit-content"
        width="194"
      />
      <div className="hackathonCardBody">
        <div className="hackathonCardBodyContent">
          <div className="hackathonTitleSec">
            <div className="hackathonTitleDiv">
              <p title={item.title} className="hackathonTitle">
                {item.title}
              </p>
              {/* {isWithinOneWeek && <div className="hackathonNewBadge">New</div>} */}
              <div>
                {currentDueLabel(item.reg_end_dt) === "Past Due" ? (
                  <div className="hackathonClosedBadge">Closed</div>
                ) : (
                  isWithinOneWeek && (
                    <div className="hackathonNewBadge">New</div>
                  )
                )}
              </div>
            </div>

            {/* prize money */}
            <div className="hackathonPrizeMoneyDiv">
              {item.prizemoney != null && (
                <div className="hackathonPrize">
                  <p>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_10972_79899)">
                        <path
                          d="M7.26249 9.625H6.73751C4.94945 9.625 3.5 7.99443 3.5 5.98281V0.4375H10.5V5.98281C10.5 7.99443 9.05011 9.625 7.26249 9.625Z"
                          fill="#F2F4F7"
                          stroke="#FF5533"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.0625 2.1875H10.7848"
                          stroke="#FF5533"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M7 9.625V13.5625"
                          stroke="#FF5533"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.5346 13.5625H3.66016L4.81252 12.25H9.18752L10.5346 13.5625Z"
                          fill="#F2F4F7"
                          stroke="#FF5533"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.5 5.6875C2.80381 5.6875 2.13614 5.41094 1.64386 4.91866C1.15157 4.42637 0.875 3.75869 0.875 3.0625C0.875 2.36631 1.15157 1.69863 1.64386 1.20634C2.13614 0.71406 2.80381 0.4375 3.5 0.4375"
                          stroke="#FF5533"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.5 5.6875C11.1962 5.6875 11.8639 5.41094 12.3561 4.91866C12.8484 4.42637 13.125 3.75869 13.125 3.0625C13.125 2.36631 12.8484 1.69863 12.3561 1.20634C11.8639 0.71406 11.1962 0.4375 10.5 0.4375"
                          stroke="#FF5533"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_10972_79899">
                          <rect width="14" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className="svgP"></div>
                    Prize: {item.prizemoney}
                  </p>
                </div>
              )}
              {/* date section  */}
              <div className="hackathonStartdate">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 1.16675V3.50008M4.66667 1.16675V3.50008M1.75 5.83342H12.25M2.91667 2.33341H11.0833C11.7277 2.33341 12.25 2.85575 12.25 3.50008V11.6667C12.25 12.3111 11.7277 12.8334 11.0833 12.8334H2.91667C2.27233 12.8334 1.75 12.3111 1.75 11.6667V3.50008C1.75 2.85575 2.27233 2.33341 2.91667 2.33341Z"
                    stroke="#FF5533"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div className="svgStartdate"></div>

                {formatDateRange(item.startdate, item.enddate)}
              </div>
            </div>
          </div>

          {/* title and loaction formating */}
          {/* <div className="hackathonOrganizer">{item.organizer}</div> */}
          <div className="hackathonOrganizer">
            {item.organizer} -
            <div className="hackathonLocationSec" style={{ display: "inline" }}>
              {item.mode === constants.HACKATHON_MODE.OFFLINE ? (
                <div className="hackathonLocation">{item.location}</div>
              ) : (
                <div className="hackathonLocation">Online</div>
              )}
            </div>
          </div>
        </div>

        <div className="hackathonCardBodyContent hackathonCardBodyContent2">
          <div className="hackathonStartdateSec">
            {/* description of hackathon */}
            <div className="hackathonDesc">{item.description}</div>
          </div>
          <div className="hackathonDetails"></div>
          <div className="hackathonLinkSec">
            <div className="adminside">
              {MANAGEMENTROLES.includes(getDataFromStorage("role")) ? (
                // <div className="hackathonCardDeleteSec">
                <Tooltip title="Delete" placement="bottom" isIcon={true}>
                  <IconButton
                    hierarchy="tertiaryGrey"
                    size="sm"
                    onClick={(event) => {
                      event.stopPropagation();
                      setShowNotify({
                        show: true,
                        titleSvg: "warning",
                        primaryButton: "Delete",
                        title: "Delete Hackathon",
                        secondaryButton: "Cancel",
                        msg: "Are you sure you want to delete this hackathon? This action cannot be undone.",
                        job: true,
                        primaryButtonFunction: () => onDelete(item.id),
                      });
                    }}
                  >
                    <svg
                      className="hackathonTrashIcon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4M6.66667 7V10.3333M9.33333 7V10.3333"
                        stroke="#98A2B3"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </IconButton>
                </Tooltip>
              ) : // </div>
              null}
              {/* recommend */}
              {MANAGEMENTROLES.includes(getDataFromStorage("role")) ? (
                <ToggleButton
                  text="Recommended"
                  size="sm"
                  pressed={item.isrecommended}
                  onChange={(value) => onToggleRecommend(value)}
                />
              ) : // <Link to={item.link} target="_blank">
              //   <svg
              //     width="16"
              //     height="16"
              //     viewBox="0 0 16 16"
              //     fill="none"
              //     xmlns="http://www.w3.org/2000/svg"
              //   >
              //     <path
              //       d="M14 6.00001L14 2.00001M14 2.00001H9.99999M14 2.00001L8 8M6.66667 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.07989 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V9.33333"
              //       stroke="#98A2B3"
              //       strokeWidth="1.4"
              //       strokeLinecap="round"
              //       strokeLinejoin="round"
              //     />
              //   </svg>
              // </Link>
              null}
            </div>
            <div className="registerP">
              <div className="regend">
                {`Registration open till ${new Date(
                  item.reg_end_dt
                ).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                })}`}
              </div>

              <button
                className="registerNowBtn"
                onClick={(event) => {
                  event.stopPropagation();
                  window.open(item.link, "_blank");
                }}
              >
                Register Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HackathonCard;
